module.exports = __webpack_public_path__ + "static/media/1.1_manual.7d8b1398.png";